export const BIB_NUMBERING_SCOPE_RACE_TYPE = 'RaceType';
export const BIB_NUMBERING_SCOPE_SHARED_RACE_POOL = 'SharedRacePool';

export interface BibNumberingConfig {
  bibNumberingEnabled?: boolean;
  bibNumberingScope?: string | null;
  bibNumberingPoolKey?: string | null;
}

export function normalizeBibNumberingConfig(config?: BibNumberingConfig | null) {
  const bibNumberingEnabled = config?.bibNumberingEnabled ?? true;
  const bibNumberingScope =
    config?.bibNumberingScope === BIB_NUMBERING_SCOPE_SHARED_RACE_POOL
      ? BIB_NUMBERING_SCOPE_SHARED_RACE_POOL
      : BIB_NUMBERING_SCOPE_RACE_TYPE;
  const bibNumberingPoolKey = config?.bibNumberingPoolKey?.trim() || '';

  return {
    bibNumberingEnabled,
    bibNumberingScope,
    bibNumberingPoolKey,
  };
}

export function getBibNumberingModeLabel(config?: BibNumberingConfig | null) {
  const normalized = normalizeBibNumberingConfig(config);

  if (!normalized.bibNumberingEnabled) {
    return 'Без стартни броеви';
  }

  if (normalized.bibNumberingScope === BIB_NUMBERING_SCOPE_SHARED_RACE_POOL) {
    return 'Заеднички pool';
  }

  return 'Одделен опсег';
}

export function getBibNumberingModeDescription(config?: BibNumberingConfig | null) {
  const normalized = normalizeBibNumberingConfig(config);

  if (!normalized.bibNumberingEnabled) {
    return 'Овој тип не добива стартни броеви.';
  }

  if (normalized.bibNumberingScope === BIB_NUMBERING_SCOPE_SHARED_RACE_POOL) {
    return normalized.bibNumberingPoolKey
      ? 'Го дели истиот numbering pool (' + normalized.bibNumberingPoolKey + ') со други типови од истиот настан.'
      : 'Го дели истиот numbering pool со други типови од истиот настан.';
  }

  return 'Стартните броеви мора да бидат единствени само во овој тип на трка.';
}

export function getBibNumberingUniquenessHint(config?: BibNumberingConfig | null) {
  const normalized = normalizeBibNumberingConfig(config);

  if (!normalized.bibNumberingEnabled) {
    return 'Овој тип не користи стартни броеви. Оставете го полето празно ако сакате да избришете постоечки legacy број.';
  }

  if (normalized.bibNumberingScope === BIB_NUMBERING_SCOPE_SHARED_RACE_POOL) {
    return normalized.bibNumberingPoolKey
      ? 'Бројот мора да биде единствен во заедничкиот pool ' + normalized.bibNumberingPoolKey + ' и да биде во дозволениот опсег.'
      : 'Бројот мора да биде единствен во заедничкиот pool и да биде во дозволениот опсег.';
  }

  return 'Бројот мора да биде единствен во овој тип на трка и да биде во дозволениот опсег.';
}
